/**
 * MypageRecentlySawPresenter
 * --
 */
import React from 'react';
import { Content, Row, Col, Title, Text } from 'components';
import { SideMenu } from '../components';

import Product from 'assets/product_01.png';
import MyItemList from '../components/ItemList/MyItemList';

const MypageRecentlySawPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const { screenSize } = props;
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */

  const styles = {
    titleLayout: {
      display: 'flex',
      gap: 8,
      alignItems: 'center',
      paddingBottom: 24,
      borderBottom: '2px solid var(--black-color)',
    },

    title: {
      fontSize: screenSize >= 768 ? 32 : screenSize >= 500 ? 28 : 20,
      fontWeight: 700,
      color: 'var(--black-color)',
    },
  };

  const myItemList = [
    {
      src: Product,
      title: '시그니처블랜드 200g',
      price: 24000,
      discount: 50,
    },
    {
      src: Product,
      title: '시그니처블랜드 617th 에비뉴 200g',
      price: 28000,
      discount: 30,
    },
    {
      src: Product,
      title: '시그니처블랜드 617th 에비뉴 200g',
      price: 28000,
      discount: 30,
    },
    {
      src: Product,
      title: '시그니처블랜드 617th 에비뉴 200g',
      price: 28000,
      discount: 30,
    },
    {
      src: Product,
      title: '시그니처블랜드 617th 에비뉴 200g',
      price: 28000,
      discount: 30,
    },
    {
      src: Product,
      title: '시그니처블랜드 617th 에비뉴 200g',
      price: 28000,
      discount: 30,
    },
    {
      src: Product,
      title: '시그니처블랜드 617th 에비뉴 200g',
      price: 28000,
      discount: 30,
    },
    {
      src: Product,
      title: '시그니처블랜드 617th 에비뉴 200g',
      price: 28000,
      discount: 30,
    },
    {
      src: Product,
      title: '시그니처블랜드 617th 에비뉴 200g',
      price: 28000,
      discount: 30,
    },
  ];

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content
      maxWidth={1820}
      padding={screenSize >= 768 ? '120px 0px' : '60px 0'}
    >
      <Row gutter={25}>
        <Col x={0} md={1} xl={2}></Col>
        <Col x={0} md={6} xl={4}>
          <SideMenu />
        </Col>
        <Col x={24} md={16} xl={16}>
          <Content
            maxWidth={'100%'}
            padding={
              screenSize >= 1200
                ? '0 0 0 95px'
                : screenSize >= 768
                ? '0 0 0 20px'
                : '0'
            }
          >
            {/* 최근 본 상품 */}
            <Content className="my_item_list" maxWidth={'100%'} padding={0}>
              <div
                style={{
                  ...styles.titleLayout,
                }}
              >
                <Title style={{ ...styles.title }}>최근 본 상품</Title>
              </div>
              <MyItemList
                title="최근 본 상품"
                items={myItemList}
                styles={styles}
              />
            </Content>
            {/* 최근 본 상품 끝 */}
          </Content>
        </Col>
        <Col x={0} md={1} xl={2}></Col>
      </Row>
    </Content>
  );
};

export default MypageRecentlySawPresenter;
